/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GamePromotionalMessageUpdateRequest
 */
export interface GamePromotionalMessageUpdateRequest {
    /**
     * 
     * @type {Date}
     * @memberof GamePromotionalMessageUpdateRequest
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GamePromotionalMessageUpdateRequest
     */
    activeFrom?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GamePromotionalMessageUpdateRequest
     */
    message?: string;
}

/**
 * Check if a given object implements the GamePromotionalMessageUpdateRequest interface.
 */
export function instanceOfGamePromotionalMessageUpdateRequest(value: object): value is GamePromotionalMessageUpdateRequest {
    return true;
}

export function GamePromotionalMessageUpdateRequestFromJSON(json: any): GamePromotionalMessageUpdateRequest {
    return GamePromotionalMessageUpdateRequestFromJSONTyped(json, false);
}

export function GamePromotionalMessageUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamePromotionalMessageUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'activeFrom': json['activeFrom'] == null ? undefined : (new Date(json['activeFrom'])),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function GamePromotionalMessageUpdateRequestToJSON(value?: GamePromotionalMessageUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'activeFrom': value['activeFrom'] == null ? undefined : ((value['activeFrom'] as any).toISOString()),
        'message': value['message'],
    };
}

